// @ts-ignore
export const all = (state) => state.all;
export const extracted = (state) => {
  const users: any[] = [];

  for (const user of state.all) {
    const newUser = { ...user };
    for (const attribute of user.Attributes) {
      newUser[attribute.Name] = attribute.Value;
    }
    users.push(newUser);
  }

  return users;
};
// @ts-ignore
export const one = (state) => state.one;
